import { render, staticRenderFns } from "./newShiftTypeMapping.vue?vue&type=template&id=0a010e4a&"
import script from "./newShiftTypeMapping.vue?vue&type=script&lang=js&"
export * from "./newShiftTypeMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCol,VForm})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a010e4a')) {
      api.createRecord('0a010e4a', component.options)
    } else {
      api.reload('0a010e4a', component.options)
    }
    module.hot.accept("./newShiftTypeMapping.vue?vue&type=template&id=0a010e4a&", function () {
      api.rerender('0a010e4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Shift/ShiftTypeMapping/components/newShiftTypeMapping.vue"
export default component.exports